'use strict';

var device = require('./device.js');

// Safari doesn't have iphone string in the userAgent
const isAppleDeviceSafari = () => {
    const userAgent = device.getUserAgent()?.toLowerCase();
    const navigatorObject = device.getNavigator();
    return (navigatorObject !== undefined &&
        navigatorObject.maxTouchPoints > 0 &&
        userAgent?.includes('safari') &&
        !userAgent?.includes('chrome'));
};
const checkIsAppleDevice = () => {
    const userAgent = device.getUserAgent();
    return userAgent !== undefined && !!(/iphone|ipad|ipod/gm.test(userAgent.toLowerCase()) || isAppleDeviceSafari());
};

exports.checkIsAppleDevice = checkIsAppleDevice;
//# sourceMappingURL=checkIsAppleDevice.js.map
